// extracted by mini-css-extract-plugin
export default {"notice":"index_notice__29M5M","message":"index_message__oP3ia","retry":"index_retry__xjHEO"};